import * as React from "react"
import { DateRangePicker } from 'rsuite'
import { DateRangePickerSeeker } from "ui-seeker/core"
import { formatDate } from "ui-seeker/utils"

import {useContextSelector} from "use-context-selector";
import {AppDatesContext} from "app/providers";


const { beforeToday } = DateRangePicker

export default function CustomDateRangePicker({ max=0, ...props }) {

	const lastDate = useContextSelector(AppDatesContext, ({state}) => state.lastDate)
	const maxDate = Date.parse(formatDate(lastDate, { format: 'yyyy-MM-dd', receivedFormat: 'yyyyMMdd', isString: true }))

	const myProps = {
		label: null,
		className: `mt-0 ${props.wrapperClassName || ''}`,
		disabledDate: d => beforeToday()(d) || d >= maxDate,
		...props
	}

    return <DateRangePickerSeeker {...myProps} />
}